declare module globalThis {
    let Ziggy: object
}

export const setupZiggy = (props: any) => {
    globalThis.Ziggy = {
        ...props.ziggy,
        location: new URL(props.ziggy.url),
    }
    Object.freeze(globalThis.Ziggy)
}

export const resolvePageComponent = async (path: string, pages: Record<string, () => Promise<any>>) => {
    for (const p of (Array.isArray(path) ? path : [path])) {
        const page = pages[p]
        if (typeof page === 'undefined') {
            continue
        }
        return typeof page === 'function' ? page() : page
    }
    throw new Error(`Page not found: ${path}`)
}
